import React from 'react';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { render } from "react-dom";
import PrerenderBoundary from './seo/PrerenderBoundary';

const root = document.getElementById('root');
render(<PrerenderBoundary><App /></PrerenderBoundary>, root);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
